import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import parseByDelimiter from '@utils/parseByDelimiter';
import DropDownPicker from 'react-native-dropdown-picker';
import useGlobalUser from '@hooks/getGlobalUser';
import apis from '@api/api';

const DataItemSelection = ({ schemaItem, dataSetId, changeCallback }: {
  schemaItem?: any
  dataSetId?: string
  changeCallback?: (val) => void
}) => {
  const [open, setOpen] = React.useState(false);
  const [items, setItems] = React.useState<{ label: string; value: string }[]>([]);
  const [selectedDataSet, setSelectedDataSet] = React.useState<string | null>(null);
  const dataFolderId = dataSetId || schemaItem?.validation?.dataSetId || schemaItem?.content?.dataSetId;

  console.log('DataItemSelection - dataFolderId:', dataFolderId);
  console.log('DataItemSelection - schemaItem:', schemaItem);

  const { data, isLoading, error } = useQuery({
    queryKey: ['individualData', dataFolderId],
    queryFn: async () => {
      console.log('Fetching data for dataFolderId:', dataFolderId);
      const response = await apis.getDataContent(dataFolderId, 'all');
      console.log('Data fetched:', response);
      return response?.data?.dataContent || [];
    },
    enabled: !!dataFolderId, // Only run query if we have a valid dataFolderId
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  useEffect(() => {
    console.log('Data changed:', data);
    if (data && Array.isArray(data)) {
      const transformed = data
        .filter((item: any) => item && item.data && item._id) // filter invalid entries
        .map((item: any) => {
          // Try to build a meaningful label from available data
          const dataKeys = Object.keys(item.data || {});
          let labelText = '';

          // Try common name fields first
          if (item.data.name || item.data.surname) {
            labelText = `${item.data.name ?? ''} ${item.data.surname ?? ''}`.trim();
          } else if (item.data.title) {
            labelText = item.data.title;
          } else if (item.data.equipment_name) {
            labelText = item.data.equipment_name;
          } else if (dataKeys.length > 0) {
            // Use the first available field value
            labelText = item.data[dataKeys[0]] || 'Unnamed Item';
          } else {
            labelText = `Item ${item._id?.slice(-6)}`;
          }

          return {
            label: parseByDelimiter(labelText),
            value: item._id,
          };
        });
      console.log('Transformed items:', transformed);
      setItems(transformed);
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      console.error('Error fetching data items:', error);
    }
  }, [error]);

  // If no dataFolderId, show error message
  if (!dataFolderId) {
    return (
      <DropDownPicker
        items={[]}
        placeholder="No dataset ID configured"
        open={false}
        setOpen={setOpen}
        disabled={true}
        value={null}
        setValue={setSelectedDataSet}
        setItems={setItems}
      />
    );
  }

  return (
    <DropDownPicker
      items={items}
      placeholder={error ? "Error loading data items" : isLoading ? "Loading..." : "Select a data item"}
      open={open}
      setOpen={setOpen}
      dropDownDirection='BOTTOM'
      loading={isLoading}
      value={selectedDataSet}
      setValue={setSelectedDataSet}
      setItems={setItems}
      onChangeValue={(value) => {
        const selected = items.find(i => i.value === value);
        if (selected) {
          setSelectedDataSet(value);
          changeCallback?.(value);
        }
      }}
      searchable={true}
      searchPlaceholder="Search for a data item"
      searchTextInputProps={{
        autoCapitalize: 'none',
        autoCorrect: false,
        returnKeyType: 'done',
        textAlign: 'left',
        placeholderTextColor: '#999',
      }}
      disabled={!!error}
    />
  )
}
export default DataItemSelection;